import { ENV } from "@/config/env";
import { STORAGE_KEYS } from "@/config/constants";
import { storage } from "@/shared/utils/storage";

export interface CallRecording {
  filename: string;
  url: string;
  start_time: string;
  end_time: string;
}

export const recordingService = {
  getRecordings: async (callId: string): Promise<CallRecording[]> => {
    const streamToken = storage.get(STORAGE_KEYS.STREAM_TOKEN);
    if (!streamToken) throw new Error("No Stream token available");

    const res = await fetch(
      `https://video.stream-io-api.com/video/call/default/${callId}/recordings`,
      {
        headers: {
          Authorization: `Bearer ${streamToken}`,
          "stream-auth-type": "jwt",
          api_key: ENV.STREAM_API_KEY,
        },
      },
    );

    if (!res.ok) {
      throw new Error(`Failed to fetch recordings: ${res.statusText}`);
    }

    const data = await res.json();
    return (data.recordings ?? []) as CallRecording[];
  },
};
